import { useQuery } from '@tanstack/vue-query';
import apiInterceptor from '@/shared/apiInterceptor';
import { environment } from '@/shared/env';
import { useSocialChannels } from '@/composables/useSocialChannels';

export function whatsappTemplatesQueryOptions(whatsappId, params = {}) {
  return {
    queryKey: ['whatsapp-templates', whatsappId, params],
    enabled: !!whatsappId,
    queryFn: async () => {
      const response = await apiInterceptor.get(
        environment('VUE_APP_API_URL') + 'social/v1/whatsapp/' + whatsappId + '/template',
        { params }
      );
      return {
        templates: response.templates,
        next: response.next,
        previous: response.prev,
        count: response.count,
      };
    },
    staleTime: 5 * 60 * 1000,
  };
}

export function useWhatsappTemplates(params = {}) {
  const { whatsAppSocialData } = useSocialChannels();
  return useQuery(
    whatsappTemplatesQueryOptions(whatsAppSocialData.value?.id, params)
  );
}
